import dayjs from 'dayjs';
import { type ICallAccount } from '@/types/ICallAccount';
import { formatCurrency } from './formatCurrency';
import { roundToTwoDecimalPlaces } from './roundToTwoDecimalPlaces';

export interface ICallAccountRow {
  label: string;
  value: string;
}

const NOT_SPECIFIED = 'не указано';

const formatText = (value: string | null | undefined): string => {
  if (typeof value !== 'string' || value.trim() === '') {
    return NOT_SPECIFIED;
  }
  return value.trim();
};

const formatBirthday = (value: string | null | undefined): string => {
  if (typeof value !== 'string' || value.trim() === '') {
    return NOT_SPECIFIED;
  }

  const date = dayjs(value);
  return date.isValid() ? date.format('DD.MM.YYYY') : NOT_SPECIFIED;
};

const formatPercent = (value: number | undefined): string => {
  if (typeof value !== 'number') {
    return NOT_SPECIFIED;
  }

  const rounded = roundToTwoDecimalPlaces(value);
  return rounded === null ? NOT_SPECIFIED : `${rounded}%`;
};

const formatAmounts = (
  purchased: number | undefined,
  purchases: number | undefined
): string => {
  if (typeof purchased !== 'number' || typeof purchases !== 'number') {
    return NOT_SPECIFIED;
  }

  return `${formatCurrency(purchased)} / ${formatCurrency(purchases)}`;
};

/**
 * Готовит строки карточки аккаунта для модалки звонка. Формулировки полей
 * совпадают со страницей клиента, чтобы менеджер видел привычные подписи.
 * В `ICallAccount` обязательны только `id` и `phone`, поэтому каждое поле
 * отдельно приводится к отображаемому виду с заглушкой «не указано».
 *
 * @param account - аккаунт из payload звонка
 * @returns список пар «подпись — значение» для рендера
 */
export const getCallAccountRows = (
  account: ICallAccount
): ICallAccountRow[] => [
  { label: 'Телефон', value: formatText(account.phone) },
  { label: 'E-mail', value: formatText(account.email) },
  { label: 'Дата рождения', value: formatBirthday(account.birthday) },
  {
    label: 'Процент выкупа товаров',
    value: formatPercent(account.percent_purchased)
  },
  {
    label: 'Сумма выкупа / Сумма заказов',
    value: formatAmounts(account.amount_purchased, account.amount_purchases)
  },
  {
    label: 'Бонусы',
    value:
      typeof account.bonus === 'number'
        ? String(account.bonus)
        : NOT_SPECIFIED
  }
];
